// extracted by mini-css-extract-plugin
export default {"convertor":"financial-info_convertor__-2RQU"};